// extracted by mini-css-extract-plugin
module.exports = {"footer":"ahead-footer_footer__3t3mM","buttonGroup":"ahead-footer_buttonGroup__17k3D","footer__inspectorTitle":"ahead-footer_footer__inspectorTitle__FBM5N"};